import React, { PureComponent } from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { withRouter } from 'react-router';

class ReloginPrompt extends PureComponent {
  render() {
    return (
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ minHeight: '100vh' }}
      >
        <Typography align="center" variant="h5" gutterBottom={true}>
          Session timed out
        </Typography>
        <Typography align="center" variant="body1" gutterBottom={true}>
          Please refresh your browser and login again.
        </Typography>
      </Grid>
    );
  }
}

export default withRouter(ReloginPrompt);
